module.exports = __webpack_public_path__ + "static/media/tms-logo.8f01e41c.png";